import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FiltroDashboardPostventa from "../Modales/FiltroDashboardPostventa";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { useBox } from "../../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import { ExcluirModelosModal } from "./ModelosExcluidosModal";
import { GarantiaCard } from "./GarantiaCard";
import Settings from "@mui/icons-material/Settings";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { MensajeGarantiaModal } from "./MensajeGarantiaModal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AgregarContactoModal from "../Cotizaciones/AgregarContactoModal";
import { GetMonthNameByNumber } from "../../../Finanzas/Helper/GetMonthNameByNumber";

export const GarantiaMenuScreen = () => {
  const history = useHistory();
//   const location = useLocation();
//   const idselected = location.state?.idselected ?? null;

  const [boxstate, setBoxState] = useBox();
  const [openModalContacto, setOpenModalContacto] = useState(false);
  const [cardSelected, setCardSelected] = useState(1);
  const [vencimientoGarantias, setVencimientoGarantias] = useState();
  const [clienteSelect, setClienteSelect] = useState();
  const [idGarantia, setIdGarantia] = useState(0);
  const [openModalExcluir, setOpenModalExcluir] = useState(false);
  const [openModalMensajes, setOpenModalMensajes] = useState(false);
  const [titulo, setTitulo] = useState('FIN DE GARANTIA');
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleOpenModalExcluir = () => {
    setOpenModalExcluir(true);
  };

  const handleCloseModalExcluir = () => {
    setOpenModalExcluir(false);
  };

  const handleOpenModalMensajes = () => {
    setOpenModalMensajes(true);
  };

  const handleCloseModalMensajes = () => {
    setOpenModalMensajes(false);
  };

  const handleOpenModalContacto = (idcliente, idGarantia) => {
    // if (!idcliente) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Cliente no registrado",
    //     text: "No se puede ingresar el contacto de un cliente no registrado.",
    //     confirmButtonText: "Entendido",
    //   });
    //   return;
    // }
    setClienteSelect(idcliente);
    setIdGarantia(idGarantia)
    setOpenModalContacto(true);
  };
  const handleCloseModalContacto = () => {
    setOpenModalContacto(false);
    setClienteSelect("");
  };

  const currentDate = new Date();
  const anioActual = currentDate.getFullYear();
  const mesActual = currentDate.getMonth() + 1;
  useEffect(() => {
    if (openModalContacto === true || openModalExcluir === true)
      return;
    onExecute(
      anioActual,
      anioActual,
      mesActual,
      mesActual,
      'C',
      boxstate.whatsapp,
      boxstate.estatus,
    );
  }, [openModalExcluir, openModalContacto]);


  const onExecute = (
    ejercicioinicio,
    ejercicioFin,
    periodo_inicio,
    periodo_fin,
    facturado,
    whatsapp,
    estatus
  ) => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    var p_fin = "";
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (
      periodo_fin === undefined ||
      periodo_fin === null ||
      periodo_fin === "" ||
      periodo_fin === "0"
    ) {
      p_fin = periodo_inicio;
    } else {
      p_fin = periodo_fin;
    }

    // if (parseInt(periodo_fin) < parseInt(periodo_inicio)) {
    //   Swal.fire(
    //     "DASHBOARD",
    //     "La fecha de inicio no puede ser Mayor a la final",
    //     "warning"
    //   );
    //   return;
    // }

    // console.log(boxstate)
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashboardPostventa/VencimientosGarantias?ejercicio_inicio=${ejercicioinicio}&ejercicio_fin=${ejercicioFin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&facturado=${facturado}&whatsapp=${whatsapp}&estado=${estatus}&adr=${adr}&sucursal=${sucursales}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setVencimientoGarantias(result);

          const mesInicio = GetMonthNameByNumber(periodo_inicio).toUpperCase();
          const mesFin = GetMonthNameByNumber(periodo_fin).toUpperCase();

          const tituloPeriodo = periodo_inicio === periodo_fin
            ? `${mesInicio} ${ejercicioinicio}`
            : `${mesInicio} - ${mesFin} ${ejercicioFin}`;

          setTitulo(`FIN DE GARANTIA ${tituloPeriodo}`);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const totalGarantias = vencimientoGarantias?.length;
  const temprana = vencimientoGarantias?.filter(
    (garantia) => garantia.grupo === "TMP"
  );
  const totalTemprana = temprana?.length;
  const tardia = vencimientoGarantias?.filter(
    (garantia) => garantia.grupo === "TRD"
  );
  const totalTardia = tardia?.length;
  const checklist = vencimientoGarantias?.filter(
    (garantia) => garantia.grupo === "FIN"
  );
  const totalChecklist = checklist?.length;

  const getGarantiasFiltradas = () => {
    if (!vencimientoGarantias) return [];

    switch (cardSelected) {
      case 1:
        return vencimientoGarantias; // Todo
      case 2:
        return vencimientoGarantias.filter(
          (garantia) => garantia.grupo === "TMP"
        ); // Temprana
      case 3:
        return vencimientoGarantias.filter(
          (garantia) => garantia.grupo === "TRD"
        ); // Tardía
      case 4:
        return vencimientoGarantias.filter(
          (garantia) => garantia.grupo === "FIN"
        ); // Checklist (solo si grupo === 'Checklist')
      default:
        return vencimientoGarantias;
    }
  };

  const onConfiguracionGarantia = () => {
    history.push("/PostVenta/ConfigurarMontos");
  };

  const agrupado = () => {
    const data = getGarantiasFiltradas();

    return [
      { titulo: "PowerWard Venta Temprana", grupo: "TMP" },
      { titulo: "PowerWard Venta Tardía", grupo: "TRD" },
      { titulo: "Fin de Garantia", grupo: "FIN" },
    ]
      .map(({ titulo, grupo }) => ({
        titulo,
        registros: data.filter((item) => item.grupo === grupo),
      }))
      .filter((g) => g.registros.length > 0); // Solo mostrar los grupos con registros
  };

  const onRegresar = () => {
    history.push("/Postventa/Main");
  };
  // console.log(clienteSelect)

  return (
    <PlantillaScreen
      titulo={titulo}
      className={"garantia-main-screen"}
      className_main={2}
    >
      <LoaderScreen loader={loader} />
      <AgregarContactoModal
        open={openModalContacto}
        onClose={handleCloseModalContacto}
        idcliente={clienteSelect}
        idGarantia={idGarantia}
      />
      <div className="garantia-actions">
        <div
          className="garantia-actions-regresar"
          onClick={() => onRegresar()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="buttons">
          <button
            className="garantia-header-configuracion"
            onClick={() => onConfiguracionGarantia()}
          >
            <Settings /> Configuracion
          </button>
          {/* <button
            className="garantia-header-mensajes"
            onClick={() => handleOpenModalMensajes()}
          >
            <WhatsAppIcon /> Mensajes
          </button> */}
          <button
            className="garantia-header-excluir"
            onClick={() => handleOpenModalExcluir()}
          >
            <DoNotDisturbIcon /> Reglas de Exclusión
          </button>
        </div>
        <div className="garantia-actions-filtro">
          <FiltroDashboardPostventa
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            mostrarestatus={true}
            mostrarwhatsapp={true}
            mostrarfacturado={true}
            ejercicio={anioActual}
            periodo_inicio={mesActual}
            periodo_fin={mesActual}
            filtroSucursales={boxstate.pv}
          />
        </div>
      </div>
      {vencimientoGarantias && vencimientoGarantias.length > 0 && (
        <>
          <div className="contador-garantia-encontrados">
            {/* Garantias encontradas: {vencimientoGarantias.length} */}
          </div>
          <div className="garantia">
            <div className="garantia-flex">
              <div className="detalle-clientes-gestionar-container-resumen">
                <GarantiaCard
                  titulo={"TOTAL"}
                  cantidad={totalGarantias}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 1);
                    setCardSelected(1);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 1 ? true : false}
                />
                <GarantiaCard
                  titulo={"VNT TEMPRANA"}
                  cantidad={totalTemprana}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 1);
                    setCardSelected(2);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 2 ? true : false}
                />
                <GarantiaCard
                  titulo={"VENTA TARDIA"}
                  cantidad={totalTardia}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 2);
                    setCardSelected(3);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 3 ? true : false}
                />
                <GarantiaCard
                  titulo={"CHECKLIST"}
                  cantidad={totalChecklist}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 4);
                    setCardSelected(4);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 4 ? true : false}
                />
              </div>
              <div className="garantia-container scroll">
                <table cellPadding={0} cellSpacing={0}>
                  <thead>
                    {/* <tr>
                                    <th colSpan={4}>Alertas de Fin de Garantia</th>
                                </tr> */}
                    <tr>
                      {/* <th ></th> */}
                      {/* <th >Modelo</th> */}
                      <th>Serie</th>
                      <th>
                        <div>Cliente</div>
                      </th>
                      <th>
                        <div>Modelo</div>
                      </th>
                      <th>
                        <div>Fecha Envio</div>
                      </th>
                      <th>
                        <div>Monto</div>
                      </th>
                      <th>
                        <div>Contacto</div>
                      </th>
                      <th>
                        <div>Estado</div>
                      </th>
                      <th>
                        <div>WH</div>
                      </th>
                      <th>
                        <div>Fac.</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {agrupado().map((grupo, i) => (
                      <React.Fragment key={i}>
                        <tr className="grupo-row">
                          <td colSpan={9} className="grupo-header">
                            {grupo.titulo}
                          </td>
                        </tr>
                        {grupo.registros.map((item, index) => (
                          <tr key={index}>
                            {/* <td>{item.modelo}</td> */}
                            <td>{item.num_serie}</td>
                            <td>{item.razon_social}</td>
                            <td>{item.modelo}</td>
                            <td className="ta-center">
                              {item.expiracion_format}
                            </td>
                            <td className="ta-right">
                              {FormatMoney(item.monto)}
                            </td>

                            <td className="celda-whatsapp ta-center">
                              {/* {item.whatsapp} */}
                              <div className="whatsapp">
                                {item.contacto === "N" ? (
                                  <div
                                    className="boton-agregar-contacto"
                                    onClick={() =>
                                      handleOpenModalContacto(item.idcliente, item.id_garantia)
                                    }
                                  >
                                    <AddCircleOutlineIcon /> Agregar
                                  </div>
                                ) : (
                                  <>{item.contacto}</>
                                )}
                              </div>
                            </td>
                            <td>{item.estado}</td>
                            <td className="ta-center">
                              {item.mensaje_enviado === "S" ? (
                                <CheckCircleIcon
                                  sx={{ color: "#5aa05b !important" }}
                                />
                              ) : (
                                <RemoveCircleIcon
                                  sx={{ color: "#7b7b7b !important" }}
                                />
                              )}
                            </td>
                            <td className="ta-center">
                              {item.contrato_adquirido === "S" ? (
                                <CheckCircleIcon
                                  sx={{ color: "#5aa05b !important" }}
                                />
                              ) : (
                                <RemoveCircleIcon
                                  sx={{ color: "#7b7b7b !important" }}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
      <ExcluirModelosModal
        open={openModalExcluir}
        onClose={handleCloseModalExcluir}
      />
      <MensajeGarantiaModal
        open={openModalMensajes}
        onClose={handleCloseModalMensajes}
        tipoGarantia={"TMP"}
      />
    </PlantillaScreen>
  );
};
